import { promptManagementApi } from 'common/api'

export type BrazeCampaign = {
  id: string
  name: string
  last_edited: string
}

export type CampaignMessage = {
  channel: string
  subject?: string
  body?: string
}

export type BrazeCampaignDetail = {
  integration: string
  campaign_id: string
  campaign_name: string
  description: string
  tags: string[]
  channels: string[]
  messages: CampaignMessage[]
}

type GetCampaignsResponse = {
  integration: string
  project_id: string
  campaigns: BrazeCampaign[]
}

export const getCampaigns = async ({
  accountId,
  projectId,
  integration,
}: {
  accountId: string
  projectId: string
  integration: string
}): Promise<BrazeCampaign[]> => {
  const result = await promptManagementApi.get<GetCampaignsResponse>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/campaigns`
  )

  return result.data.campaigns
}

type GetCanvasesResponse = {
  integration: string
  project_id: string
  canvases: BrazeCampaign[]
}

export const getCanvases = async ({
  accountId,
  projectId,
  integration,
}: {
  accountId: string
  projectId: string
  integration: string
}): Promise<BrazeCampaign[]> => {
  const result = await promptManagementApi.get<GetCanvasesResponse>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/canvas`
  )

  return result.data.canvases
}

export const getCampaignDetail = async ({
  accountId,
  projectId,
  integration,
  brazeCampaignId,
}: {
  accountId: string
  projectId: string
  integration: string
  brazeCampaignId: string
}): Promise<BrazeCampaignDetail> => {
  const result = await promptManagementApi.get<BrazeCampaignDetail>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/campaigns/${brazeCampaignId}`
  )

  return result.data
}
